// An in-app link: a real anchor (open in a new tab works) that navigates without a reload through
// the host it is mounted in.
import type { ComponentChildren } from "preact";
import { isPlainLeftClick, useHost } from "../host/host";

export function Link({
  href,
  children,
  class: className,
  current,
  onNavigate,
  "aria-label": ariaLabel,
}: {
  href: string;
  children: ComponentChildren;
  class?: string | undefined;
  current?: boolean | undefined;
  /** Called after a client-side navigation (the drawer closes itself with it). */
  onNavigate?: (() => void) | undefined;
  "aria-label"?: string | undefined;
}) {
  const host = useHost();
  return (
    <a
      href={href}
      class={className}
      aria-current={current ? "page" : undefined}
      aria-label={ariaLabel}
      onClick={(event) => {
        if (!isPlainLeftClick(event)) return;
        event.preventDefault();
        host.navigate(href);
        onNavigate?.();
      }}
    >
      {children}
    </a>
  );
}
